export const NOTIFICATION_CREATE_TOPIC_V2 =
  'notification.cmd.notification-create-v2';
export const NOTIFICATION_REMOVE_TOPIC = 'notification.cmd.notification-remove';

export const NOTIFICATION_ERROR_UNSUPPORTED_TYPE =
  'notification.error.notification-type-unsupported';
